module.exports = __webpack_public_path__ + "static/logo-gruppo-home-56ad177d50a479d3fbf365a011c7b079.png";